export const API_BASE_URL = "https://meaty-thin-quilt.strapiapp.com/api";
export const API_GRAPHQL = "https://meaty-thin-quilt.strapiapp.com/graphql";
